<template>
  <div id="search" :class="{'showSm': !isShowSm}">
    <div class="container-wrapper" style="overflow: hidden;">
      <img src="./img/titile-big.png" alt="" class="title-big" v-if="isShowSm">
      <div class="search-label">
        <el-select v-model="value" popper-class="select-option">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          :readonly="readonlyShow" 
          @focus="focusHandle"
          placeholder="请输入检索关键词"
          v-model="input"
          class="search-input"
          @keyup.enter.native="handleSearch"
          clearable>
        </el-input>
       <img src="./img/search-btn.png" alt="" class="search-btn"  @click="handleSearch">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      options: [
        {
          value: 'Content',
          label: '正文'
        },
        {
          value: 'Title',
          label: '题名'
        },
        {
          value: 'BookTitle',
          label: '志书名'
        },
        {
          value: 'Editor',
          label: '编纂人员'
        },
        {
          value: 'Editorial',
          label: '编纂单位'
        },
        {
          value: 'Publisher',
          label: '出版单位'
        }],
      value: '正文',
      input: '',
      readonlyShow:true
    }
  },
  computed: {
    isShowSm () {
      return this.$route.name === 'Home' ? 1 : 0
    }
  },
  methods: {
    // 检索
    handleSearch (e) {
      let input = ''
      if (this.input) {
        if (this.value === '正文') {
          this.value = 'Content'
        }
        input = (this.value + ':' + this.input.trim())
      }
      if ((this.input).trim() === '') {
        alert('请输入检索词')
        return
      }
      this.$router.push({path: 'searchItem', query: {query: input}})
    },
    _intitInput () {
      if (this.$route.name === 'SearchItem') {
        this.input = this.$route.query.query.split(':')[1] || ''
      } else {
        this.input = ''
      }
    },
    async focusHandle(){
      this.readonlyShow = true;
      if (await this.$loginAuthentication.intercept(1)) {
        this.readonlyShow = false;
      } else {
        this.$message.warning('请先登录账号！');
      }
    }
  },
  mounted () {
    this._intitInput()
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this._intitInput()
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scope>
#search {
  background: url("./img/Search-bg-big.png") no-repeat;
  background-size: 100% 100%;
  background-position: center;
  text-align: center;
  padding-bottom: 118px;
  &.showSm {
    background: url("./img/Search-bg-sm.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    padding-bottom: 73px;
  }
  .title-big {
    display: block;
    padding-top: 110px;
    margin: 0 auto;
  }
  .el-select {
    width: 136px;
    height:60px;
    border-radius:4px 4px 0 0;
    float: left;
    border: none;
    font-size: 16px;
    .el-input {
      width: 138px !important;
      .el-input__inner {
        border: none;
        height: 60px;
        font-size: 16px;
        color: #333;
        text-align: center;
      }
    }
  }
  .search-label {
    margin: 0 auto;
    margin-top: 60px;
    width:860px;
    height:60px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 6px 0px rgba(23,33,58,0.64);
    border-radius:4px;
    position: relative;
    box-sizing: border-box;
    .search-input {
      width: 658px;
      height: 60px;
      border-radius:0 0 4px 4px;
      float: left;
      border: none;
      font-size: 16px;
      color: #999999;
      .el-input__inner{
        border: none;
        height: 60px;
        font-size: 16px;
      }
    }
    .search-btn {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: 21px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/Search.vue